import axios from "axios";
import * as actionTypes from "./ActionTypes";
import { toast } from "react-toastify";

// get all the withdrawal requests
export const GetWithdrawRequestsList = (page = 1) =>
    async (dispatch) => {
        dispatch({
            type: actionTypes.WITHDRAWAL_REQUESTS_LIST_INIT,
        });

        try {
            const authToken = localStorage.getItem("authToken");
            const config = {
                headers: {
                    Authorization: authToken ? `Bearer ${authToken}` : "",
                },
            };
            const response = await axios.get(
                `https://app.loungebridge.com/api/admin/withdraw?page=${page}`,
                config
            );

            if (response.status === 200) {
                dispatch({
                    type: actionTypes.WITHDRAWAL_REQUESTS_LIST_SUCCESS,
                    payload: response.data,
                });
            } else {
                dispatch({
                    type: actionTypes.WITHDRAWAL_REQUESTS_LIST_FAIL,
                    payload: "Failed to fetch records",
                });
                toast.error("Failed to fetch records");
                return false;
            }
        } catch (error) {
            if (error.response?.status === 401 || error.response?.status === 403) {
                localStorage.removeItem("authToken");
                toast.error("Session expired. Please log in again.");
                window.location.href = "/login";
            } else {
                dispatch({
                    type: actionTypes.WITHDRAWAL_REQUESTS_LIST_FAIL,
                    payload: error.response ? error.response.data : "An error occurred",
                });
                toast.error("Failed to fetch users");
            }
            return false;
        }
    };

// change the stauts of requests
export const ChangeReuestStatus = (status, id) => async (dispatch) => {
    
    dispatch({
        type: actionTypes.CHANGE_REQUEST_STATUS_INIT,
    });

    try {
        const authToken = localStorage.getItem("authToken");
        const config = {
            headers: {
                Authorization: authToken ? `Bearer ${authToken}` : "",
            },
        };
        const payload = {
            status,
        }

        const response = await axios.put(
            `https://app.loungebridge.com/api/admin/withdraw-request/${id}`,
            payload,
            config
        );
        
        if (response.status === 200) {
            dispatch({
                type: actionTypes.CHANGE_REQUEST_STATUS_SUCCESS,
                payload: response.data,
            });
            return response.data;
        } else {
            dispatch({
                type: actionTypes.CHANGE_REQUEST_STATUS_FAIL,
                payload: "Failed to change the stauts",
            });

            return false;
        }
    } catch (error) {
        if (error.response?.status === 401 || error.response?.status === 403) {
            localStorage.removeItem("authToken");
            toast.error("Session expired. Please log in again.");
            window.location.href = "/login";
        } else {
            dispatch({
                type: actionTypes.CHANGE_REQUEST_STATUS_FAIL,
                payload: error.response ? error.response.data : "An error occurred",
            });
            toast.error(error?.response?.data?.message || "Failed to change the status");
        }
        return false;
    }
}